export default __webpack_public_path__ + "339d41967797c7d4f41a0addcc659196.svg";